import { types } from "../types/createProject";
import { types as notificationTypes } from "../types/notifications";

const initialState = {
  geojsonReady: false,
  topographyReady: false,
  topoConversionInProgress: false,
  topoConversionResultUrl: null,
  geojsonCheckInProgress: false,
  geojsonCheckResultUrl: null,
  geojsonUploadInProgress: false,
  topographyUploadInProgress: false,
  uploadedTopographyUrl: null,
  uploadedGeojsonUrl: null,
  requestId: null,
  newProject: null,
  isCreating: false,
  errors: [],
  polygonDataUrl: null,
};

const createProjectReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INIT_CREATE_PROJECT:
      return {
        ...initialState,
        isCreating: true,
        newProject: action.payload.newProject,
        topographyReady: action.payload.topographyUrl ? false : true,
        geojsonReady: action.payload.geojsonUrl ? false : true,
      };
    case types.CREATE_PROJECT_SUCCESS:
      return {
        isCreating: false,
      };
    case types.CREATE_PROJECT_FAILURE:
      return {
        isCreating: false,
        errors: [...state.errors, action.payload],
      };
    case types.UPLOAD_GEOJSON:
      return {
        ...state,
        geojsonUploadInProgress: true,
        geojsonReady: false,
      };
    case types.UPLOAD_GEOJSON_SUCCESS:
      return {
        ...state,
        geojsonUploadInProgress: false,
        uploadedGeojsonUrl: action.payload,
      };
    case types.UPLOAD_TOPOGRAPHY:
      return {
        ...state,
        topographyUploadInProgress: true,
        topographyReady: false,
      };
    case types.UPLOAD_TOPOGRAPHY_SUCCESS:
      return {
        ...state,
        topographyUploadInProgress: false,
        uploadedTopographyUrl: action.payload,
      };
    case types.SET_CHECK_GEOJSON_REQUEST:
      return {
        ...state,
        geojsonCheckRequestId: action.payload,
        geojsonCheckInProgress: true,
      };
    case types.SET_CONVERT_TOPOGRAPHY_REQUEST:
      return {
        ...state,
        topoConversionRequestId: action.payload,
        topoConversionInProgress: true,
      };
    case notificationTypes.CREATE_NOTIFICATION:
      const { type, status, resultUrl, error, additionalData } = action.payload;
      if (type === "geojsonCheck") {
        if (status === 2) {
          return {
            ...state,
            geojsonCheckInProgress: false,
            geojsonCheckResultUrl: resultUrl,
            geojsonReady: true,
            polygonDataUrl: additionalData?.userPolygonData,
          };
        }
        if (status === 3) {
          return {
            ...state,
            isCreating: false,
            geojsonCheckInProgress: false,
            errors: [...state.errors, error],
          };
        }
      }
      if (type === "TopographyConversionNotificationReceived") {
        if (status === 2) {
          return {
            ...state,
            topoConversionInProgress: false,
            topoConversionResultUrl: resultUrl,
            topographyReady: true,
          };
        }
        if (status === 3) {
          return {
            ...state,
            topoConversionInProgress: false,
            uploadedTopographyUrl: null,
            errors: [...state.errors, error],
            isCreating: false,
          };
        }
      }
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default createProjectReducer;
